<template><div><h2>ButtonTab</h2>
<ul>
<li>[feature] 添加更多<code>less</code>变量 #896 @erguotou520</li>
</ul>
<h2>Datetime</h2>
<ul>
<li>[feature] 支持配置<code>取消</code>和<code>确定</code>的文字颜色 #715 @greedying</li>
</ul>
<h2>Tab</h2>
<ul>
<li>[feature] 支持设置 <code>bar-active-color</code> #715 @greedying</li>
</ul>
<h2>XButton</h2>
<ul>
<li>[feature] 添加<code>less</code>变量 #896 @erguotou520</li>
</ul>
<h2>XInput</h2>
<ul>
<li>[feature] 添加<code>slot=label</code>自定义label部分内容 #895 @erguotou520</li>
</ul>
<h2>XNumber</h2>
<ul>
<li>[enhance] 使用<code>svg</code>代替 <code>+</code> <code>-</code> 字符</li>
<li>[feature] 支持圆形按钮样式</li>
</ul>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.46_zh-CN-293.vue?45022b74